import { Component, component, app } from "modular-openscriptjs";
import { dom, Draggable as DraggableCore } from "../../fotastart";
import { uniqueId } from "../../helpers";

const h = app("h");

export default class Draggable extends Component {
    render(config, ...args) {
        const key = config?.id || uniqueId();
        const options = config?.options || {};
        this.key = key;
        this.options = options;

        return h.div(
            {
                id: key,
                class: "wab-draggable-wrapper",
                onmousedown: h.func("handleDragStart", "${event}", options),
                ontouchstart: h.func("handleDragStart", "${event}", options),
            },
            ...args,
        );
    }

    $_mounted(componentId) {
        const c = component(componentId);
        const el = dom.id(c.key);
        if (c && el) {
            DraggableCore.init(el, c.options);
        }
    }
}
